/**
 * Shared selected-date store.
 *
 * Used by the app header (date stepper) and date-aware pages (e.g. Today)
 * so they stay in sync. Not persisted — resets to "now" on reload.
 */

type Listener = (date: Date) => void;

class SelectedDateService {
  private _date: Date = new Date();
  private listeners = new Set<Listener>();

  get date(): Date {
    return this._date;
  }

  set(date: Date): void {
    this._date = date;
    this.listeners.forEach((l) => l(this._date));
  }

  shiftDays(days: number): void {
    const next = new Date(this._date);
    next.setDate(next.getDate() + days);
    this.set(next);
  }

  goToToday(): void {
    this.set(new Date());
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const selectedDateService = new SelectedDateService();
